import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from './mobileMenu'

import { FaMediumM } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import { FaTelegramPlane } from 'react-icons/fa'

import { FaBars } from 'react-icons/fa6'

const NAV_LINKS = [
  {
    name: 'ABOUT',
    linkPath: '#about',
  },
  {
    name: 'NFT HODLERS',
    linkPath: '#nft',
  },
  {
    name: 'FEATURES',
    linkPath: '#features',
  },
  {
    name: 'PREMIUM SERVICE',
    linkPath: '#premiumservices',
  },
]

export default function Navbar() {
  const [menuShow, setMenuShow] = useState(false)

  const HandleClick = () => {
    setMenuShow(true)
  }

  return (
    <div className='relative'>
      <nav className='md:px-10 px-5 py-6 bg-black flex items-center justify-between '>
        <div>
          <a
            href='/'
            className='transition animate__backInDown animate__animated wow'
          >
            <img
              src='/images/logo.png'
              alt='logo'
              className='w-[289px] h-10'
            />
          </a>
        </div>
        <div className='flex items-center gap-14'>
          <div className='lg:block hidden'>
            <ul className='flex items-center gap-10'>
              {NAV_LINKS.map((item, index) => (
                <li
                  key={index}
                  className={`font-semibold `}
                >
                  <a
                    href={item.linkPath}
                    className='transition animate__backInDown animate__animated wow ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 block'
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className='md:flex hidden items-center gap-5'>
            <a
              href=''
              className='transition animate__backInDown animate__animated wow'
            >
              <FaMediumM />
            </a>
            <a
              href=''
              className='transition animate__backInDown animate__animated wow'
            >
              <FaXTwitter />
            </a>
            <a
              href=''
              className='transition animate__backInDown animate__animated wow'
            >
              <FaTelegramPlane />
            </a>
          </div>
          <div className='lg:hidden block relative'>
            <button onClick={HandleClick}>
              <FaBars />
            </button>
          </div>
        </div>
      </nav>
      <div className='animation'>
        {menuShow && <MobileMenu setMenuShow={setMenuShow} />}
      </div>
    </div>
  )
}
